module.exports = __webpack_public_path__ + "static/career_banner-8938056db42eae39e126fe5982e10dd4.jpg";